import React, { FC, ReactElement, ReactNode } from 'react'
import RcTooltip from 'rc-tooltip'
import styles from './tooltip.module.scss'

interface TooltipProps {
  align?: any
  children: ReactElement
  mouseEnterDelay?: number
  overlay: ReactNode
  overlayClassName?: string
  overlayInnerClassName?: string
  placement?: string
}

export const Tooltip: FC<TooltipProps> = ({
  align,
  overlay,
  children,
  overlayClassName,
  overlayInnerClassName,
  placement = 'top',
  mouseEnterDelay,
}) => {
  return (
    <RcTooltip
      align={align}
      mouseEnterDelay={mouseEnterDelay}
      overlay={
        <div className={overlayInnerClassName || styles.overlay}>{overlay}</div>
      }
      overlayClassName={overlayClassName || styles.tooltip}
      placement={placement}
    >
      {children}
    </RcTooltip>
  )
}
